/* eslint-disable import/no-webpack-loader-syntax */

import basicRenderFragmentShader from "!!raw-loader!./render_basic.frag";
import edlRenderFragmentShader from "!!raw-loader!./render_edl.frag";
import outputRenderFragmentShader from "!!raw-loader!./render_output.frag";
import commonRenderVertexShader from "!!raw-loader!./render_common.vert";
import pointCloudFragmentShader from "!!raw-loader!./pointcloud.frag";
import pointCloudVertexShader from "!!raw-loader!./pointcloud.vert";
import panoramicFragmentShader from "!!raw-loader!./panoramic.frag";
import panoramicVertexShader from "!!raw-loader!./panoramic.vert";
import planarFragmentShader from "!!raw-loader!./planar.frag";
import planarVertexShader from "!!raw-loader!./planar.vert";
import markersFragmentShader from "!!raw-loader!./markers.frag";
import markersVertexShader from "!!raw-loader!./markers.vert";
import utilitiesShader from "!!raw-loader!./utilities.glsl";
import gpuPickerFragmentShader from "!!raw-loader!./gpu_picker.frag";
import gpuPickerVertexShader from "!!raw-loader!./gpu_picker.vert";
import texturePackVertexShader from "!!raw-loader!./texture_pack.vert";
import tagsFragmentShader from "!!raw-loader!./tags.frag";
import tagsVertexShader from "!!raw-loader!./tags.vert";
import basicPickerFragmentShader from "!!raw-loader!./picker_basic.frag";
import basicPickerVertexShader from "!!raw-loader!./picker_basic.vert";
import lineworkSpriteFragmentShader from "!!raw-loader!./linework_sprite.frag";
import lineworkSpriteVertexShader from "!!raw-loader!./linework_sprite.vert";
import lineworkBasicFragmentShader from "!!raw-loader!./linework_basic.frag";
import lineworkBasicVertexShader from "!!raw-loader!./linework_basic.vert";
import IFCFragmentShader from "!!raw-loader!./ifc.frag";
import IFCVertexShader from "!!raw-loader!./ifc.vert";

const shaders = {
  ifc: {
    vert: IFCVertexShader,
    frag: IFCFragmentShader
  },
  pointcloud: {
    vert: pointCloudVertexShader,
    frag: pointCloudFragmentShader
  },
  panoramic: {
    vert: panoramicVertexShader,
    frag: panoramicFragmentShader
  },
  planar: {
    vert: planarVertexShader,
    frag: planarFragmentShader
  },
  linework_basic: {
    vert: lineworkBasicVertexShader,
    frag: lineworkBasicFragmentShader
  },
  linework_sprite: {
    vert: lineworkSpriteVertexShader,
    frag: lineworkSpriteFragmentShader
  },
  render_edl: {
    vert: commonRenderVertexShader,
    frag: edlRenderFragmentShader
  },
  render_basic: {
    vert: commonRenderVertexShader,
    frag: basicRenderFragmentShader
  },
  render_transition: {
    vert: commonRenderVertexShader,
    frag: outputRenderFragmentShader
  },
  markers: {
    vert: markersVertexShader,
    frag: markersFragmentShader
  },
  utilities: utilitiesShader,
  basic_picker: {
    vert: basicPickerVertexShader,
    frag: basicPickerFragmentShader
  },
  gpu_picker: {
    vert: gpuPickerVertexShader,
    frag: gpuPickerFragmentShader
  },
  texture_packer: {
    vert: texturePackVertexShader
  },
  tags: {
    vert: tagsVertexShader,
    frag: tagsFragmentShader
  }
};

export default shaders;